import { useTranslation } from 'react-i18next';

interface NotesFieldProps {
  value: string;
  onChange: (v: string) => void;
  maxLength?: number;
}

export function NotesField({ value, onChange, maxLength = 2000 }: NotesFieldProps) {
  const { t } = useTranslation();
  return (
    <div>
      <label className="block text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1.5">
        {t('wizard.modal.notesLabel')}
      </label>
      <p className="text-xs text-slate-400 mb-1.5">{t('wizard.modal.notesHelperText')}</p>
      <textarea
        rows={3}
        value={value}
        onChange={(e) => onChange(e.target.value.slice(0, maxLength))}
        maxLength={maxLength}
        placeholder={t('wizard.modal.notesPlaceholder')}
        className="w-full border border-hairline rounded px-3 py-2 text-sm bg-bone-soft focus:outline-none focus:border-copper resize-none"
      />
      <p className="text-xs text-slate-400 mt-1 text-right">
        {value.length} / {maxLength}
      </p>
    </div>
  );
}
